import { Container, ScrollArea, Table, Center, Text, Loader, Group, Paper, Pagination, Stack, Alert, Tooltip, UnstyledButton } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from '../Home/Home.module.css'
import { faDownload, faPlaneLock } from '@fortawesome/free-solid-svg-icons';


const recordsPerPage = 20;

const TableWithLoaderConciliaciones = ({ heigth, allData, headers, selectedValue }) => {

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const totalPages = Math.ceil(allData.length / recordsPerPage);

    function safeUrl(input) {
        try {
            const url = new URL(input);
            if (url.protocol !== "https:" && url.protocol !== "http:") {
                throw new Error("Invalid protocol");
            }
            return url.toString();
        } catch {

            return null;
        }
    }

    const DescargaFunction = () => {
        fetch(process.env.REACT_APP_API_ENP + "/sscn-back/api/utils/getS3LinkConciliacionesCSV?id=" + selectedValue,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                    "Content-Type": "application/json",
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error while getting S3 link! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {

                const s3Url = data?.link;
                if (!s3Url) throw new Error("S3 URL not found in response");
                showNotification({
                    title: 'Listo!',
                    message: 'Iniciando descarga del archivo',
                    color: '#fff',
                    styles: (theme) => ({
                        root: {
                            backgroundColor: '#25A661',
                            borderColor: '#25A661',
                            '&::before': { backgroundColor: theme.white },
                        },
                        title: { color: theme.white },
                        description: { color: theme.white },
                        closeButton: {
                            color: theme.white,
                        },
                    }),
                    autoClose: true,
                })
                const link = document.createElement("a");
                link.href = s3Url;
                // const validatedUrl = safeUrl(s3Url);
                // if (!validatedUrl) return;

                // const link = document.createElement("a");
                // link.href = encodeURI(validatedUrl);

                link.download = "alertas.csv"; // or .csv, .txt, etc.

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((err) => {
                showNotification({
                    title: 'Error!',
                    message: err.response?.data?.error ? err.response.data.error : err.message,
                    color: '#fff',
                    styles: (theme) => ({
                        root: {
                            backgroundColor: '#E93F19',
                            borderColor: 'E93F19',
                            '&::before': { backgroundColor: theme.white },
                        },
                        title: { color: theme.white },
                        description: { color: theme.white },
                        closeButton: {
                            color: theme.white,
                        },
                    }),
                    autoClose: false,
                })
            });
    }

    return (
        <>
            <div style={{ gridColumn: '1 / -1' }}>

                <Alert variant="light" color="yellow" radius="xl" title="Importante!">
                    Solo se visualizan 200 registros, si deseas ver todo el contendio descarga el archivo por favor!
                </Alert>
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
                <Stack spacing="md" align="flex-end">
                    <Paper height={2} shadow="lg" radius="lg" withBorder p={0}>
                        <Group justify="center" gap={0}>
                            <Tooltip label="Descarga" position="right" transitionProps={{ duration: 0 }}>
                                <UnstyledButton onClick={DescargaFunction} className={classes.link}>
                                    <FontAwesomeIcon icon={faDownload} size="lg" />
                                </UnstyledButton>
                            </Tooltip>
                        </Group>
                    </Paper>
                </Stack>
            </div>

            <div style={{ gridColumn: '1 / -1' }}>
                <Paper shadow="xl" radius="xl" withBorder p="xl">
                    {loading ? (
                        <Center h={heigth}>
                            <Loader color="rgba(250, 0, 115, 1)" type="dots" size={100} />
                        </Center>
                    ) : allData.length !== 0 ? (
                        <ScrollArea h={heigth}>
                            <Table stickyHeader>
                                <Table.Thead>
                                    <Table.Tr>
                                        {headers.map((header, index) => (
                                            <Table.Th key={index} style={{ textAlign: 'center' }}>
                                                {header}
                                            </Table.Th>
                                        ))}
                                    </Table.Tr>
                                </Table.Thead>
                                <Table.Tbody>
                                    {allData.map((row, rowIndex) => (
                                        <Table.Tr key={rowIndex}>
                                            {headers.map((header, colIndex) => (
                                                <Table.Td key={colIndex} style={{ textAlign: 'center' }}>
                                                    {row[header] ?? '-'}
                                                </Table.Td>
                                            ))}
                                        </Table.Tr>
                                    ))}
                                </Table.Tbody>
                            </Table>
                        </ScrollArea>
                    ) : (
                        <Center h={heigth}>
                            <Container>
                                <Text c="dimmed" size="lg" ta="center" p={36}>
                                    Sin datos encontrados
                                </Text>
                                <Text c="dimmed" size="lg" ta="center">
                                    <FontAwesomeIcon icon={faPlaneLock} size="3x" />
                                </Text>
                            </Container>
                        </Center>
                    )}
                </Paper>
            </div>

            {/* Pagination control */}
            {!loading && totalPages > 1 && (
                <div style={{ gridColumn: '1 / -1' }}>
                    <Stack spacing="md" align="flex-end">
                        <Paper height={2} shadow="lg" radius="lg" withBorder p="sm">
                            <Pagination
                                color="rgba(2, 12, 65, 1)"
                                total={totalPages}
                                value={currentPage}
                                onChange={setCurrentPage}
                            />
                        </Paper>
                    </Stack>
                </div>
            )}
        </>
    );
};

export default TableWithLoaderConciliaciones;